require('javascripts/navigation')
require('javascripts/cookie-policy-onscroll')
require('javascripts/honeybadger')

// would very much like to remove this...
require('bootstrap-sass/assets/javascripts/bootstrap')
